import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';

type Props = {
  chatInstanceId: number;
  onSuccess?: () => void;
};

export const useToggleChatBookmark = ({ chatInstanceId, onSuccess }: Props) => {

  const dispatch = useContext(ChatStateDispatchContext);

  const apiClient = useChatApiClient();

  const mutation = useMutation({
    mutationKey: ['chat:patch:bookmark'],

    mutationFn: (bookmarked: boolean) => {
      return apiClient.chatInstances.toggleChatInstanceBookmark({
        chatInstanceId,
        bookmarked,
      });
    },

    onSuccess: res => {
      dispatch({
        type: 'chat-instance-bookmarked',
        payload: {
          chatInstance: {
            id: chatInstanceId,
            bookmarked: res.bookmarked,
          },
        },
      });
      onSuccess?.();
    },
  });

  return mutation;
};